import React from 'react';
import { Route } from 'react-router-dom';

import NoAccessPage from '../../components/LandingPage/NoAccessPage';
import { useAppSelector } from '../../store/hooks';
import { ROLES } from '../../enums/ROLES';

type TProtectedRoute = {
  path: string;
  component: React.ComponentType;
  roles?: ROLES[];
  exact?: boolean;
};

const ProtectedRoute: React.FC<TProtectedRoute> = ({ path, exact, component: Component, roles }) => {
  const currentUserRole = useAppSelector((state) => state.user.role);

  if (!roles) {
    return <Route path={path} exact={exact} children={<Component />} />;
  }
  if (currentUserRole && roles.includes(currentUserRole)) {
    return <Route path={path} exact={exact} children={<Component />} />;
  }

  if (currentUserRole) {
    return <Route path={path} exact={exact} children={<NoAccessPage />} />;
  }
  return null;
};

export default ProtectedRoute;
